import store from "@/app/store/store";
import { AssureEditionEnum, BatteryTypeEnum } from "@/app/api/battery-portal-api";
export function isLicenseAllowed(rule) {
    if (!rule)
        return true;
    const hostingOption = store.getters["licenseModule/hostingOption"];
    const appEdition = store.getters["licenseModule/appEdition"];
    // Only check hosting option if rule specifies one
    if (rule.hostingOption !== undefined && hostingOption !== rule.hostingOption) {
        return false;
    }
    // Check minimum edition requirement
    if (rule.minimumEdition !== undefined) {
        const editionHierarchy = [
            AssureEditionEnum.OnPremBasic,
            AssureEditionEnum.OnPremStandard,
            AssureEditionEnum.OnPremPremium
        ];
        const currentIndex = editionHierarchy.indexOf(appEdition);
        const requiredIndex = editionHierarchy.indexOf(rule.minimumEdition);
        // Cloud Standard has access to all features
        if (appEdition !== AssureEditionEnum.PowershieldCloudStandard) {
            if (currentIndex < requiredIndex) {
                return false;
            }
        }
    }
    return true;
}
/**
 * Returns a short human-readable reason describing why an edition-gated control is disabled,
 * suitable for a tooltip (title="..."). Returns null when the rule is satisfied or when it is
 * only hosting-gated (hosting mismatches hide the element entirely, so no tooltip is needed).
 */
export function getLicenseDisabledReason(rule) {
    if (!rule)
        return null;
    if (isLicenseAllowed(rule))
        return null;
    if (rule.minimumEdition === undefined)
        return null;
    return `Available in ${editionLabel(rule.minimumEdition)} edition or above`;
}
function editionLabel(edition) {
    switch (edition) {
        case AssureEditionEnum.OnPremBasic: return "Basic";
        case AssureEditionEnum.OnPremStandard: return "Standard";
        case AssureEditionEnum.OnPremPremium: return "Premium";
        case AssureEditionEnum.PowershieldCloudStandard: return "Cloud Standard";
        default: return "a higher";
    }
}
export function getPermissionsForEdition(permissions) {
    if (!permissions || permissions.length === 0)
        return [];
    return permissions.filter(p => {
        // If both constraints are null/undefined, the rule is satisfied.
        if (p.hostingOption === undefined && p.minimumEdition === undefined)
            return true;
        // Reuse the same hosting/edition matching used by route license rules
        // so behaviour stays consistent across the app.
        return isLicenseAllowed({
            hostingOption: p.hostingOption,
            minimumEdition: p.minimumEdition,
        });
    });
}
/**
 * Chemistry-aware drill-down gating (Option C).
 * Lithium systems require Standard edition or higher for hyperlinked drill-down insights.
 * Non-lithium chemistries (lead-acid, etc.) are unrestricted.
 * Cloud currently has no chemistry-specific constraints; cloud editions satisfy the standard-or-higher check.
 */
export function isChemistryDrillDownAllowed(batteryTypeId) {
    if (batteryTypeId !== BatteryTypeEnum.Lithium)
        return true;
    return !!store.getters["licenseModule/isStandardOrHigher"];
}
export function getChemistryDrillDownDisabledReason(batteryTypeId) {
    if (isChemistryDrillDownAllowed(batteryTypeId))
        return null;
    return "Available in Standard edition or above for Lithium systems";
}
